/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    // dropzone
    window.dropzone = require("dropzone");
    Dropzone.autoDiscover = false;

    // moment
    global.moment = require("moment");
    // default date format
    moment.locale("en-AU");

    // require('tempusdominus-bootstrap-4');
    // require('bootstrap-3-typeahead');
} catch (e) {}
